import { savePluginData, getPluginData, deletePluginData } from '@/api/bom/plugins/item-data-plugin'

export default {
  state: {
    alternates: {} // keyed by bom item id.
  },
  getters: { },
  mutations: {
    setPluginData (state, { plugin, itemId, data }) { // multiple alternates data of a BOM item
      state[plugin] = Object.assign({}, state[plugin], { [itemId]: data || [] })
    },
    updatePluginData (state, { plugin, itemId, data }) { // update single alternate data of a BOM item
      let ind = _.findIndex(state[plugin][itemId], { id: data.id })
      if (ind >= 0) {
        state[plugin][itemId][ind] = data
      } else {
        state[plugin][itemId].push(data)
      }
    },
    deletePluginData (state, { plugin, itemId, key }) { // delete single alternate from bom item
      let ind = _.findIndex(state[plugin][itemId], { id: key })
      if (ind > 0) {
        state[plugin][itemId].splice(ind, 1)
      }
    }
  },
  actions: {
    saveBomItemPluginData ({ commit }, { plugin, itemId, data }) {
      return savePluginData(plugin, data).then(resp => {
        commit('updatePluginData', { plugin: plugin, itemId: itemId, data: resp.data })
        return resp
      })
    },
    setBomItemPluginData ({ commit }, { plugin, itemId, data }) {
      commit('setPluginData', { plugin: plugin, itemId: itemId, data: data })
    },
    getBomItemPluginData ({ commit }, { plugin, query }) {
      return getPluginData(plugin, query).then(resp => {
        commit('setPluginData', { plugin: plugin, itemId: query.bom_item_id, data: resp.data })
        return resp
      })
    },
    deleteBomItemPluginData ({ commit }, { plugin, itemId, key }) {
      return deletePluginData(plugin, { id: key }).then(resp => {
        commit('deletePluginData', { plugin: plugin, itemId: itemId, key: key })
        return resp
      })
    }
  }
}
